import { getFilterNameFn } from "@components/dimension-panel-hz/drawer/utils";
import { DIMENSION_WRAPPER_ID } from "@components/dimension-panel-hz/utils";
import { COMPARE_TYPES } from "@store/trends/base/reducer";
import { SUMMARY_PANEL_CONTROLS_ID } from "../SummaryContainer/utils";

export const getFilterName = getFilterNameFn(COMPARE_TYPES.trends);

export const COMPARE_FILTERS_BAR_ID = 'compare-filters-bar';

export const scrollToTables = () => {
  const dimensionWrapper = document.getElementById(DIMENSION_WRAPPER_ID);
  if(dimensionWrapper) {
    dimensionWrapper.scrollIntoView({ behavior: 'smooth' });
  }
}

export const scrollToCompareFiltersBar = () => {
  const summaryPanel = document.getElementById(SUMMARY_PANEL_CONTROLS_ID);
  if(summaryPanel) {
    summaryPanel.scrollIntoView({ behavior: 'smooth' });
  }
}


export const COMPARE_SERIES_LOADING_STATE_EVENT = 'compare-series-loading-state-event';

export const dispatchComparLoadingStateChangeEvent = (eventDetail) => {
  const loadingEvent: any = new CustomEvent(COMPARE_SERIES_LOADING_STATE_EVENT, {
    detail: eventDetail,
  });
  document.dispatchEvent(loadingEvent);
};

